import { render, staticRenderFns } from "./SuiteTemplateWebsite.vue?vue&type=template&id=79c70a2a&"
import script from "./SuiteTemplateWebsite.vue?vue&type=script&lang=js&"
export * from "./SuiteTemplateWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports